import { EventBookingStatus, EventSystemStatus, ISummaryCalendlyEvent } from 'api-paths-cas';

export const getActiveScheduledInterviews = (calendlyInterviews: ISummaryCalendlyEvent[]): ISummaryCalendlyEvent[] => {
  return calendlyInterviews.filter(
    (interview: ISummaryCalendlyEvent) =>
      interview.bookingStatus !== EventBookingStatus.CANCELED &&
      interview.systemStatus !== EventSystemStatus.DELETED &&
      interview.systemStatus !== EventSystemStatus.FAILED,
  );
};
